import { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { exportMarketYoyGrowthExpectations } from '../../../../api/exportMarketYoyGrowthExpectations'
import { TMarketYoyGrowthExpectationRtm } from '../../../../api/types'
import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../../../configs/translations'

interface IExportButtonProps {
  fYear: number
  rtm: TMarketYoyGrowthExpectationRtm
  isDisabled: boolean
}

export const ExportButton = ({ fYear, rtm, isDisabled }: IExportButtonProps) => {
  const [isExporting, setIsExporting] = useState(false)

  const onExport = useCallback(async () => {
    setIsExporting(true)

    try {
      await exportMarketYoyGrowthExpectations({ fYear, rtm })
    } finally {
      setIsExporting(false)
    }
  }, [fYear, rtm])

  return (
    <Button
      size="sm"
      icon="kbase kbase-download"
      loading={isExporting}
      disabled={isDisabled}
      onClick={onExport}
    >
      <Translation text={MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS.export} />
    </Button>
  )
}

ExportButton.displayName = 'ExportButton'
